import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import ReactStrapTable from "components/reactStrapTable";
import DownloadIcon from 'assets/icon/icon-icon-options-download.svg';
import DownloadIconHover from 'assets/icon/icon-icon-options-download_hover.svg';
import NotesIcon from 'assets/icon/Notes.svg';
import NotesIconHover from 'assets/icon/Notes_Hover.svg';

import HoverImage from "react-hover-image/build";
import { cellRendererCheck, dateFormate } from "utils/columns";

const QueryToolTable = (props) => {

    const {
        tabledata,
        Retry,
        download,
        onExport
    } = props;
	const [ isOpen, setisOpen ] = useState(false);
    const[errordetaildata,setErrorDetailData]=useState("")
const handletoggle = (row) => {
        
		setisOpen(!isOpen);
        setErrorDetailData(row.errorDetail)
	};
    const renderButtons = (row) => {
        return (
            <div >
                <Button
                    hidden={row.status !== "Generated"}
                    className='text-primary p-0 text-decoration-none'
                    // style={{marginLeft:"10px"}}
                    color='link'
                    onClick={() => download(row)}
                    title="Click To Download Query Report Details"
                > <span>
                        <HoverImage
                            key='DownloadIcon'
                            src={DownloadIcon}
                            hoverSrc={DownloadIconHover}
                            alt=''
                        />
                    </span>
                </Button>
                {row.errorDetail?  <Button 
                    className='text-primary p-0 text-decoration-none' 
                    color='link'
                     onClick={() => handletoggle(row)}
                     style={{marginLeft:0}}
                    title="Error Details"
                > <span>
                        <HoverImage
                            key='RefreshIcon'
                            src={NotesIcon}
                            hoverSrc={NotesIconHover}
                            alt=''
                        />
                    </span>
                </Button>:""}
              
            </div>
        );
    };

    let maincol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (row) => renderButtons(row),
            width: 90,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'status',
            text: 'Status',
            width: 80,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.status)
        },
        {
            dataField: 'queryName',
            text: 'Report Template',
            width: 150,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.queryName)
        },
        {
            dataField: 'reportName',
            text: 'Report Name',
            width: 150,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.reportName)
        },
        {
            dataField: 'requestedBy',
            text: 'Requested By',
            width: 120,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.requestedBy)
        },
        {
            dataField: 'requestedDate',
            text: 'Requested Date',
            width: 140,
            show: true,
            inputType: 'date',
            cellRenderer: (row) => dateFormate(row.requestedDate)
        },
        {
            dataField: 'dateGenerated',
            text: 'Date Generated',
            width: 100,
            show: true,
            inputType: 'date',
            cellRenderer: (row) => dateFormate(row.dateGenerated)
        },
        {
            dataField: 'retryCount',
            text: 'Retry Count',
            width: 100,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.retryCount)
        },
        
        {
            dataField: 'recordCount',
            text: 'Record Count',
            width: 100,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.recordCount)
        },
        // {
        //     dataField: 'parametersJson',
        //     text: 'ParametersJson',
        //     width: 200,
        //     show: true,
        //     inputType: 'text',
        //     cellRenderer: (row) => cellRendererCheck(row.parametersJson)
        // },
        // {
        //     dataField: 'errorDetail',
        //     text: 'Error Detail',
        //     width: 130,
        //     show: true,
        //     inputType: 'text',
        //     cellRenderer: (row) => cellRendererCheck(row.errorDetail)
        // },
        // {
        //     dataField: 'createdByID',
        //     text: 'Created By ID',
        //     width: 120,
        //     show: true,
        //     inputType: 'text',
        //     cellRenderer: (row) => cellRendererCheck(row.createdByID)
        // },
        // {
        //     dataField: 'createdDate',
        //     text: 'Created Date',
        //     width: 150,
        //     show: true,
        //     inputType: 'date',
        //     cellRenderer: (row) => dateFormate(row.createdDate)
        // },
        // {
        //     dataField: 'modifiedByID',
        //     text: 'Modified By ID',
        //     width: 140,
        //     show: true,
        //     inputType: 'text',
        //     cellRenderer: (row) => cellRendererCheck(row.modifiedByID)
        // },
        // {
        //     dataField: 'modifiedDate',
        //     text: 'Modified Date',
        //     width: 150,
        //     show: true,
        //     inputType: 'date',
        //     cellRenderer: (row) => dateFormate(row.modifiedDate)
        // }
    ];

    let data = [];

    return (
        <div
            className='table-card scroll-table position-relative border-0  rounded pt-0'
        >
            <ReactStrapTable
                id='pendingfiles-sf'
                data={tabledata}
                columns={maincol}
                onExport={onExport}
                // pageSize={10}
                // displayrecords={true}
                // filtercolumn={true}

                // hasExportPermission={hasExportPermission}
            />
<Modal isOpen={isOpen} toggle={handletoggle} size="xxl">
				<ModalHeader toggle={handletoggle}>Error Details</ModalHeader>
				<ModalBody style={{ minHeight: 200 }}>
				
				<div style={{
wordWrap: "break-word",
overflowWrap: 'break-word',
whiteSpace: "normal", 
overflow: "hidden",
}}>
                    <p>
{errordetaildata}

                    </p>

                </div>
					
					
					
				</ModalBody>
			
			</Modal>
        </div>
    );
};

export default QueryToolTable;